import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fe-enterprises',
    templateUrl: './enterprises-lp.component.html',
    styleUrls: ['./enterprises-lp.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EnterprisesLpComponent implements OnInit {
    constructor(
        private titleService: Title,
        private metaService: Meta,
        private translateService: TranslateService,
    ) {}
    ngOnInit(): void {
        this.updateSeoTags();
    }

    updateSeoTags() { 
        this.translateService
            .get('fe_meta_seo_title_corporate')
            .subscribe((title: string) => {
                this.titleService.setTitle(title);
            });

        this.translateService
            .get('fe_meta_seo_description_corporate')
            .subscribe((description: string) => {
                this.metaService.updateTag({
                    name: 'description',
                    content: description,
                });
            });

        this.translateService
            .get('fe_meta_seo_keywords')
            .subscribe((keywords: string) => {
                this.metaService.updateTag({
                    name: 'keywords',
                    content: keywords,
                });
            });
    }
}
